

import React from 'react';
import Header from '../header';
import Toolbar from './toolbar';
import './style_portfolio.css';
import ProfilePicture from "profile-picture"
import "profile-picture/build/ProfilePicture.css"
import {   TextField ,Fab} from '@material-ui/core';
import {Button, FormControl,Modal} from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import {Navbar,Nav,Form} from 'react-bootstrap';

export default class Portfolio2 extends React.Component{
    constructor(props) {
        super(props)
        const [show, setShow] = [false,false];
    
        const handleClose = () => setShow(false);
        const handleShow = () => setShow(true);
        this.profilePictureRef = React.createRef();
      }
      addSection(){
    console.log(document.getElementById("modal"));
      }
    handleUpload() {
        const PP = this.profilePicture.current;
        const imageData = PP.getData();
        const file = imageData.file;
        const imageAsDataURL = PP.getImageAsDataUrl();
    
       
        //add here the upload logic...
      }
render(){
    return (
        <div style={{backgroundColor:"black",height:"860px"}}>

<Toolbar/>
<Navbar bg="dark" variant="dark" style={{fontSize:'18px'}}>
      <Nav className="mr-auto">
        <Nav.Link href="/create_portfolio2" active>Home</Nav.Link>
        <Nav.Link href="/create_portfolio2/about">About</Nav.Link>
        <Nav.Link href="/create_portfolio2/work">Work</Nav.Link>
      </Nav>
      <Form inline style={{fontSize:'18px'}}>
       	&nbsp;&nbsp;
        <a style={{color:"white"}} href="/create_portfolio2/contact" style={{fontSize:'18px'}}>Contact</a>
      </Form>
    </Navbar>
    <br/>    <br/>
    <br/>
    <br/>
    <br/>
    <div style={{display:"flex"}}>
    <div style={{marginLeft:"70px",width:"550px",backgroundColor:"white",display:"grid",borderRadius:"10px"}}>
<TextField 
   
   autoComplete="fname"
           variant="outlined"
           required
           style={{marginTop:"20px",marginLeft:"10px",marginRight:"80px"}}
           type="name"
           
           id="name"
           label="Your fucking name"
           autoFocus/>
        
            <TextField 
  
  autoComplete="fname"
          variant="outlined"
          required
          
          style={{marginTop:"10px",marginLeft:"10px",marginRight:"10px"}}

          type="name"
          
          id="name"
          label="Your fucking Job"
          /> <br/> <br/>
                      <FormControl 
                      style={{marginLeft:"10px",width:"530px"}}
                      htmlSize="26" as="textarea" aria-label="With textarea" value="Describe yourself in few words..." />

           <br/> <br/>
</div>
<div style={{display:"grid",marginLeft:"400px"}}>
<ProfilePicture
    
    ref={this.profilePictureRef}
    useHelper={true}
    debug={true}
  />
  
  <Button onClick={this.handleUpload.bind(this)} variant="outline-info" style={{ marginLeft:"03px"}} >Upload</Button>
  
</div>

    </div>

   


</div>
    )
}

}